import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22bde717"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col tw-gap-[4px]" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "tw-text-[#878787] tw-max-w-[300px] tw-flex-wrap tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[normal] sublabel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`inputWrapper tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-items-start md:tw-items-center tw-gap-[10px] tw-flex-wrap ${
      _ctx.required ? 'required' : ''
    }`)
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createElementVNode("label", {
        class: "tw-relative tw-text-[#231f20] tw-text-[14px] tw-font-medium tw-mb-[0px] tw-leading-[100%]",
        for: _ctx.id
      }, _toDisplayString(_ctx.label), 9, _hoisted_2),
      (_ctx.sublabel)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.sublabel), 1))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 2))
}